import React, { Component, Fragment, useEffect, useState } from "react";
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { Link } from "react-router-dom";
import '../Navigation.css'
import CardService from "../components/CardService";

import checked from "../assets/icons/checked.svg";


import port from "../assets/images/delvalleport.jpeg";
import logodv from "../assets/icons/logodv.png";
//logo facebook youtube

import iconFacebook from "../assets/icons/facebook.png";
import iconYoutube from "../assets/icons/whatsapp.svg";


import beforeOne from '../assets/images/before1.jpg'
import beforeTwo from '../assets/images/before2.jpg'

import afterOne from '../assets/images/after1.jpg'
import afterTwo from '../assets/images/after2.jpg'
import Footer from "./Footer";
import Apoinment from "./Apoinment";
import Reviews from "./Reviews";
import CardWork from "./CardWork";
import ProjectList from './ProjectList'
import Gallery from './Gallery'

const Home = () => {


  const [services, setServices] = useState([


    {
      img: 'https://firebasestorage.googleapis.com/v0/b/delvalleconstructionllc170.appspot.com/o/walkways.jpeg?alt=media&token=047db965-fbbb-44de-b76c-b09b94296eb0',
      description: 'Make your new Walkways Look beautiful with the best quality ever used ! We offer any type of finish !',
      name: 'Walkways'

    },
    {
      img: 'https://firebasestorage.googleapis.com/v0/b/delvalleconstructionllc170.appspot.com/o/steps.jpeg?alt=media&token=4b49af81-9d78-49ef-b71a-0b5e77604e80',
      description: 'Make your new Steps Look beautiful with the best quality ever used ! We offer any type of finish !',
      name: 'Steps'
    },
    {
      img: 'https://firebasestorage.googleapis.com/v0/b/delvalleconstructionllc170.appspot.com/o/patios.jpeg?alt=media&token=5235f145-cf39-4816-8ce9-9e8a920f1b16',
      description: 'Make your new Patios Look beautiful with the best quality ever used ! We offer any type of finish !',
      name: 'Patios'
    },
    {
      img: 'https://firebasestorage.googleapis.com/v0/b/delvalleconstructionllc170.appspot.com/o/foundation.jpeg?alt=media&token=f9ff82fa-3f93-40f8-a19c-6a5992d34fd4',
      description: 'Make your new Foundations Look beautiful with the best quality ever used ! We offer any type of finish !',
      name: 'Foundations'
    },
    {
      img: 'https://firebasestorage.googleapis.com/v0/b/delvalleconstructionllc170.appspot.com/o/driveways.jpeg?alt=media&token=f87e789e-2d3e-4ab7-80ef-e3009cce725b',
      description: 'Make your new Driveway Look beautiful with the best quality ever used ! We offer any type of finish !',
      name: 'Driveway'
    },

    {
      img: 'https://fritzstonework.com/wp-content/uploads/2020/02/retaining-wall-st-louis.png',
      description: 'Make your new Retaining walls Look beautiful with the best quality ever used ! We offer any type of finish !',
      name: 'Retaining walls'
    },
    {
      img: 'https://firebasestorage.googleapis.com/v0/b/delvalleconstructionllc170.appspot.com/o/sidewalls.jpeg?alt=media&token=6ac4ec99-9ea0-4e25-9678-a5afa1f1bea8',
      description: 'Make your new Side walks Look beautiful with the best quality ever used ! We offer any type of finish !',
      name: 'Side walks'
    },
    {
      img: 'https://firebasestorage.googleapis.com/v0/b/delvalleconstructionllc170.appspot.com/o/works%2Fcurbing.jpg?alt=media&token=a5c2118d-aac7-4313-b8cd-d3b5fe7508d1',
      description: 'Make your new Curbing Look beautiful with the best quality ever used ! We offer any type of finish !',
      name: 'Curbing'
    }
  ]);






  const listItems = services.map((service) =>
    <CardWork url={service.img} titleCard={service.name} description={service.description} ></CardWork>);








  return (
    <Fragment>
      {/**Contact bar */}
      <div className="contactHero">
        <Navbar bg="ligth" expand="lg">
          <Navbar.Brand href="/">
            <img src={logodv} alt="Logo" style={{ width: '100px' }} />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ml-auto">


              <Nav.Link href="/">Home</Nav.Link>
              <Nav.Link href="#aboutus">About us</Nav.Link>
              <Nav.Link href="#services">Services</Nav.Link>




              <Nav.Link href="#contact">Contact Us</Nav.Link>
              <Nav.Link href="https://www.facebook.com/Delvalleconstructionllc" tarjet="_blank"><img src={iconFacebook} style={{ width: '25px' }} alt="" srcset="" /></Nav.Link>
              <Nav.Link href="https://api.whatsapp.com/send?phone=4253462198&text=I%20want%20more%20information%20about%20you"><img src={iconYoutube} style={{ width: '25px' }} alt="" srcset="" /></Nav.Link>

            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>

      {/**Hero */}
      <div className="jumbotron heroPage">
        <h1 className="centerText">Best Service, Right Time, Right People</h1>
        <a href="tel:425346-2198" className="btn btnPrimary botonChido">
          Get Free Estimates
        </a>
      </div>

      <div style={{ textAlign: "center" }}>


        <article>
        <div style={{ height: '20px' }}></div>
          <h1 id='aboutus' style={{ fontSize: '30px' }} className='titleSection'>About us</h1>
          <div className='textDescription'>
            <i>We offer a full range of quality concrete work with customer service always being our top priority. We are extremely dedicated and devoted in our work, we are proud of what we do and want you to be just as proud in your investment.</i>
          </div>
          <div style={{ height: '20px' }}></div>
        </article>



        <div>
          <div style={{ height: '20px' }}></div>
          <h1 id='services' style={{ fontSize: '30px' }} className="titleSection">Services Offered</h1>
          <div style={{ height: '20px' }}></div>
        </div>


        <div className='containerPosts'>{listItems}</div>



        <article style={{ padding: '10px' }} className="containerProjects">
          <div style={{ height: '20px' }}></div>

          <h1 style={{ fontSize: '30px' }} className="titleSection">⭐️Our lasted  projects⭐️</h1>

          <Gallery></Gallery>
          <div style={{ height: '20px' }}></div>

        </article>
      </div>


      <div>
        <div style={{ height: '20px' }}></div>
        <h1 style={{ color: '#101010', fontSize: '25px', lineHeight: '50px', textAlign: 'center' }} className='titleStep'>Variety of concrete finishes offered including: Stamped, Exposed Aggregate, Broom and Sand.</h1>
        <div style={{ height: '20px' }}></div>
      </div>


      <article id='contact' className='apoinmentSection'>

        <Apoinment></Apoinment>
      </article>

      <div style={{ height: '20px' }}></div>
      <Reviews></Reviews>


      <Footer></Footer>



    </Fragment>
  );
};

export default Home;
